module.exports = __webpack_public_path__ + "static/media/story-text-xl.7ee736a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/story-text-xl.png
// module id = 610
// module chunks = 0